import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import AiSupportWidget from './components/AiSupportWidget';
import DiscountPopup from './components/DiscountPopup';
import MoleculeBackground from './components/MoleculeBackground';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import { About, Contact, Wishlist } from './pages/Static';
import { CartProvider } from './context/CartContext';

function App() {
  return (
    <div className="App min-h-screen relative" style={{ backgroundColor: '#ffffff' }}>
      <MoleculeBackground />
      <div className="relative z-10">
        <CartProvider>
          <BrowserRouter>
            <Header />
            <CartDrawer />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/sklep" element={<Shop />} />
                <Route path="/kategoria/:categorySlug" element={<Shop />} />
                <Route path="/produkt/:id" element={<ProductDetail />} />
                <Route path="/o-nas" element={<About />} />
                <Route path="/kontakt" element={<Contact />} />
                <Route path="/ulubione" element={<Wishlist />} />
              </Routes>
            </main>
            <Footer />
            <AiSupportWidget />
            <DiscountPopup />
          </BrowserRouter>
        </CartProvider>
      </div>
    </div>
  );
}

export default App;
